(function () {
  'use strict';
  var guide = document.querySelector('[data-gj-fee-guide]');
  if (!guide || !window.GJMarketPricing) return;
  var service = window.GJMarketPricing.create({productUrl:guide.dataset.productUrl,productId:guide.dataset.productId,currency:guide.dataset.currency,country:guide.dataset.country,themeId:guide.dataset.themeId});
  var catalogPromise, labels=new Map(), failed=new Set(), pending=new Map();
  function label(code) {
    if(labels.has(code))return Promise.resolve(labels.get(code));
    if(pending.has(code))return pending.get(code);
    if(!catalogPromise)catalogPromise=fetch(guide.dataset.catalogUrl).then(function(r){if(!r.ok)throw new Error('Fee catalog unavailable');return r.json();});
    var task=catalogPromise.then(function(catalog){
      var variants=catalog.plans.leather.variants;
      if(!variants[code])throw new Error('Unknown fee');
      return Promise.all([service.request(variants['0']),service.request(variants[code])]);
    }).then(function(prices){
      if(prices[1]<prices[0])throw new Error('Invalid fee');
      var text=new Intl.NumberFormat(undefined,{style:'currency',currency:guide.dataset.currency,currencyDisplay:'code'}).format((prices[1]-prices[0])/100);
      labels.set(code,text);return text;
    }).finally(function(){pending.delete(code);});
    pending.set(code,task);return task;
  }
  function fill(node) {
    var code=node.dataset.gjFee;
    if(failed.has(code)){node.textContent='See builder';return;}
    label(code).then(function(text){if(node.isConnected&&node.textContent!==text)node.textContent=text;}).catch(function(){failed.add(code);if(node.isConnected)node.textContent='See builder';});
  }
  function scan(parent) {
    if(parent.nodeType!==1&&parent.nodeType!==9)return;
    if(parent.matches&&parent.matches('[data-gj-fee]'))fill(parent);
    parent.querySelectorAll('[data-gj-fee]').forEach(fill);
  }
  scan(document);
  new MutationObserver(function(records){
    records.forEach(function(record){record.addedNodes.forEach(scan);});
  }).observe(document.body,{childList:true,subtree:true});
}());
